export default class MediaRepository {

    constructor(mediaApiService) {
        if (new.target === MediaRepository) {
            throw new Error("Cannot instantiate an abstract class.");
        }
        if (this.getChatImages === MediaRepository.prototype.getChatImages) {
            throw new Error("Class extending MediaRepository must override 'getChatImages({ chatChannelId, skip, limit })'.");
        }

        this.mediaApiService = mediaApiService;
    }

    async getChatImages({ chatChannelId, skip, limit = 50 }) {
        throw new Error("Method 'getChatImages({ chatChannelId, skip, limit })' must be implemented.");
    }
}